import React from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  return (
    <Container className="mt-5 text-center">
      <Row className="justify-content-center">
        <Col md={6}>
          <h1 className="display-1">404</h1>
          <h2>Oops! Page Not Found</h2>
          <p className="lead">The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.</p>
          
          <div>
            <Button
              as={Link as any}
              to="/"
              variant="primary"
              className="me-3"
            >
              Go to Home
            </Button>
            <Button
              as={Link as any}
              to="/dashboard"
              variant="outline-primary"
            >
              Go to Dashboard
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFoundPage; 